import React from 'react'
import classnames from 'classnames'

import { ModalContent } from 'src/shared/components/common/modal'
import { t } from 'src/translations'
import { LoadingSpinner } from 'shared/components/common/loading_spinner/LoadingSpinner'

type LogoutProps = {
  error?: boolean
  isMobile?: boolean
}

export const Logout = ({ error, isMobile = false }: LogoutProps) => {
  return (
    <ModalContent
      contentClassName={classnames('logoutModalContent', isMobile && 'mobile')}
      disableFocusTrap
    >
      <div className='body' data-testid='Logout'>
        {error ? (
          <div className='errorContent'>
            <div className='text error'>{t('logout.log-out-failed')}</div>
            <p>{t('logout.something-went-wrong')}</p>
          </div>
        ) : (
          <>
            <div className='spinnerContainer'>
              <LoadingSpinner color='#7A7A7A' size='16' />
            </div>
            <div className='text'>{t('logout.logging-out')}</div>
          </>
        )}
      </div>
    </ModalContent>
  )
}
